module.exports = __webpack_public_path__ + "img/10.4d848be5.png";